import { render, staticRenderFns } from "./PurposeInfoMain.vue?vue&type=template&id=07ab9541&scoped=true&"
var script = {}
import style0 from "./PurposeInfoMain.vue?vue&type=style&index=0&id=07ab9541&lang=scss&scoped=true&"
import style1 from "./PurposeInfoMain.vue?vue&type=style&index=1&id=07ab9541&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ab9541",
  null
  
)

export default component.exports